/** Summary card / ranking / aggregate change label (decoupled from API comparison object). */
export function getSummaryComparisonLabel(preset: string | undefined): string | undefined {
    if (!preset) return undefined;

    switch (preset) {
        case 'wtd':
        case 'last_7_days':
            return 'WoW';
        case 'last_14_days':
            return 'Prior 14 days';
        case 'this_month':
            return 'MoM';
        case 'last_30_days':
            // Rolling 30-day block vs prior 30 — not calendar month-over-month.
            return 'Prior 30 days';
        case 'this_quarter':
            return 'QoQ';
        case 'last_3_months':
            return 'Prior 90 days';
        case 'last_6_months':
            return 'Prior 6 mo';
        case 'last_year':
            return 'Prior year';
        default:
            return undefined;
    }
}

/** Timeseries tooltip / per-bucket change label. Prefer preset so week bars are not always "WoW". */
export function getTimeseriesComparisonLabel(
    preset: string | undefined,
    granularity?: string,
): string | undefined {
    const fromPreset = getSummaryComparisonLabel(preset);
    if (fromPreset) return fromPreset;

    if (granularity === 'month') return 'MoM';
    if (granularity === 'week' || granularity === 'biweekly') return 'WoW';

    return undefined;
}
